import React from "react";

const ResumeUploadModal = ({
  show,
  uploading,
  file,
  resumeInputRef,
  onClose,
  onFileSelect,
  onUploadClick,
}) => {
  if (!show) return null;

  return (
    <div className="upload-modal">
      <div className="modal-content">
        <div className="modal-head">
          <div></div>
          <h3>Upload Resume</h3>
          <img src="/images/close-icon.svg" alt="" onClick={onClose} />
        </div>
        <div className="modal-input">
          {uploading ? (
            <div
              style={{
                textAlign: "center",
                color: "#F75891",
                justifyContent: "center",
              }}
            >
              <p style={{ fontWeight: "600", fontSize: "16px" }}>
                Uploading resume...
              </p>
            </div>
          ) : (
            <>
              <p>Supported formats: PDF, DOCX</p>
              <button
                className="upload-btn"
                onClick={() => resumeInputRef.current.click()}
                disabled={uploading}
              >
                Browse Resume
              </button>
              <input
                type="file"
                accept=".pdf,.docx"
                ref={resumeInputRef}
                style={{ display: "none" }}
                onChange={onFileSelect}
              />
              {file && file.name && (
                <p>
                  Selected: <strong>{file.name}</strong>
                </p>
              )}
            </>
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button className="upload-btn" disabled={uploading} onClick={onUploadClick}>
            {uploading ? "Uploading..." : "Upload Resume"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResumeUploadModal;
